/* eslint-disable jsx-a11y/no-noninteractive-element-to-interactive-role */
import React from 'react';
import PropTypes from 'prop-types';

import Icon from '../../../../base/Icon';
import NMLoginButton from '../../../../../assets/js/components/nm_login_button.component';
import NmSearch from '../../../../../assets/js/components/nmx-search.component';
import NmUserLogin from '../../../../../assets/js/components/nm_user_login.component';

export const UtilityNavigationComponent = ({ env }) => (
  <React.Fragment>
    <div className="nmx-row nmx-row--align-right">
      <div
        className="nmx-col nmx-nav-utility-container"
        id="nav-utility-container">
        <nav
          itemScope
          itemType="https://schema.org/SiteNavigationElement"
          className="nmx-nav-utility"
          id="nmx-nav-utility">
          <h6 className="nmx-assistive-text">Utility Navigation</h6>
          <ul role="menu" className="reduced">
            <li
              role="none"
              itemProp="name"
              className="nmx-nav-link-utility-container nmx-nav-link-utility-container-mobile-button">
              <a
                role="menuitem"
                itemProp="url"
                className="nmx-nav-link nmx-nav-link-utility"
                href="/find-a-financial-advisor"
                id="nmx-nav-link-utility-fafa">
                Find a Financial Advisor
              </a>
            </li>
            <li
              role="none"
              itemProp="name"
              className="nmx-nav-link-utility-container nmx-nav-link-utility-container-mobile-button">
              <a
                role="menuitem"
                itemProp="url"
                className="nmx-nav-link nmx-nav-link-utility"
                href="/claims"
                id="nmx-nav-link-utility-claims">
                Claims
              </a>
            </li>
            <li
              role="none"
              itemProp="name"
              className="nmx-nav-link-utility-container"
              id="nmx-nav-link-login-button-container">
              <div className="nmx-login-button">
                <NMLoginButton env={env} />
              </div>
            </li>
            <li
              role="none"
              itemProp="name"
              className="nmx-nav-link-utility-container"
              id="nmx-nav-link-search-container">
              <button
                role="menuitem"
                className="nmx-button nmx-nav-link nmx-nav-link-utility"
                id="nmx-nav-link-utility-search">
                Search
                <Icon variant='search' className='nmx-icon-search' />

              </button>
            </li>
          </ul>
        </nav>
      </div>
    </div>
    <div className="nmx-row">
      <div className="nmx-col">
        <div id="nmx-search-console"><NmSearch id="nmx-search-console" env={env} /></div>
      </div>
    </div>
    <NmUserLogin className="nmx-base" env={env} />
  </React.Fragment>
);

UtilityNavigationComponent.propTypes = {
  /** Env vars used for varying components */
  env: PropTypes.shape({
    basePath: PropTypes.string.isRequired,
    nmxTemplateVersion: PropTypes.string.isRequired,
    public: PropTypes.shape({
      googlePlacesApiKey: PropTypes.string,
      googleFloodlightsId: PropTypes.string,
      googleAnalyticsTrackingId: PropTypes.string,
    }).isRequired,
    services: PropTypes.shape({
      loginPageUrl: PropTypes.string.isRequired,
      loginPageUrlBase: PropTypes.string.isRequired,
      userLogoutUrls: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
};

UtilityNavigationComponent.defaultProps = {
  env: {
    userLogoutUrls: '<%=userLogoutUrls%>',
    googleFloodlightsId: '<%=googleFloodlightsId%>',
    googleAnalyticsTrackingId: '<%=googleAnalyticsTrackingId%>',
    googlePlacesApiKey: '<%=googlePlacesApiKey%>',
    templateBasePath: '<%=templateBasePath%>',
    loginPageUrl: '<%=loginPageUrl%>',
    loginPageUrlBase: '<%=loginPageUrlBase%>',
  },
};

export default UtilityNavigationComponent;
